import React from 'react';

const MyReview = () => {
    return (
        <div>
            <h2 className="text-3xl">My Review</h2>
        </div>
    );
};

export default MyReview;